import script from "./CheckoutPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckoutPage.vue?vue&type=script&setup=true&lang=js"

import "./CheckoutPage.vue?vue&type=style&index=0&id=d47cf9d8&scoped=true&lang=css"

import exportComponent from "/workspaces/e-commerce-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d47cf9d8"]])

export default __exports__